import { motion } from 'framer-motion';
import { useHistory } from 'react-router';
import { css } from 'styled-components';

import { LAST_ANIMATION_DELAY } from 'src/app/components/FeatureLayouts/SimpleFeatureLayout/constants';
import { SimpleFeatureLayout } from 'src/app/components/FeatureLayouts/SimpleFeatureLayout/SimpleFeatureLayout';
import { EscriptOnboardingStepName } from 'src/app/components/Pages/EscriptOnboarding/types';
import { useSegmentEvent } from 'src/app/hooks/useSegmentEvent';
import { newOnboardingStep } from 'src/app/router/paths';

const mixBlendMultiply = css`
  mix-blend-mode: multiply;
`;

const StethoscopeArt = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 375 283">
    <path fill="#fff" d="M0 0h375v283H0z" />
    <circle cx="188" cy="141" r="105" fill="#99BFBC" />
    <motion.g
      id="hiw-stethoscope"
      animate={{
        translateX: [0, 1, -1, 1, -1, 0],
        translateY: [0, 1, -1, 1, -1, 0],
        rotate: [0, 0.5, -0.5, 0.5, -0.5, 0],
        scale: [1, 1.01, 1.02, 1.01, 1],
      }}
      transition={{
        ease: 'easeInOut',
        repeat: Infinity,
        repeatType: 'reverse',
        duration: 6,
        delay: LAST_ANIMATION_DELAY,
      }}
    >
      <path
        fill="#DFECEA"
        fillRule="evenodd"
        d="M188.13 84.25c3.87 0 7.03-3.1 7.12-6.95 6.65-1.26 11.67-.4 15.04 2.6 9.67 8.6 6.02 33.08 3 52.83a54.2 54.2 0 0 1-.45 3.47 3.31 3.31 0 0 0-1.9 2.76c-1.94 23.4-6.66 35.86-14.18 37.8-7.51 1.93-17.82-6.23-31.35-25.56a3.5 3.5 0 0 0-3.43-1.4 61.65 61.65 0 0 1-2.15-2.68c-12.45-15.46-27.92-35-23.84-47.24 1.35-4.4 5.42-7.79 12.08-10a7.12 7.12 0 1 0-1.05-3.17c-7.66 2.5-12.51 6.7-14.25 12.1-4.46 13.8 11.26 33.7 24.07 49.93l.41.53c.8.9 1.53 1.75 2.24 2.6a3.34 3.34 0 0 0 .34 3.2c8.47 12.05 18.93 25.09 29.92 28.12l8.1 9.64a26.97 26.97 0 0 0 6.56 8.81c-11.38 2.58-21.26 8.38-27.91 16.54-8.16 10.3-10.74 24.26-6.45 35.64 4.3 11.6 15.68 19.54 27.27 19.54h3.23c8.37-1.07 16.53-6.44 22.11-14.6 10.53-15.46 9.67-36.93-1.72-51.53a97.73 97.73 0 0 1 20.83 3.86c4.51 1.29 9.02 3 13.32 4.73 1.52.52 3.06 1.08 4.61 1.65 4.15 1.5 8.4 3.05 12.78 4.14l1.37.35c8.77 2.2 19.33 4.86 28.96 2.4a13.96 13.96 0 1 0-2.67-6.4c-8.25 1.7-17.88-.8-25.94-3-5.58-1.5-11.17-3.65-16.75-5.8-4.51-1.72-9.02-3.44-13.74-4.94-10.74-3.22-20.83-4.72-30.06-4.08l-.22-.21-.5-.38-.02-.01c-3.05-2.29-6.14-4.6-8.4-8.6l1.36-11.96c2.73-2.75 4.99-6.65 6.78-11.68 2.37-6.87 3.87-15.67 4.94-27.7a3.17 3.17 0 0 0-1.31-3.03l.03-.19c.16-1.07.32-2.14.42-3.22 3.23-20.4 6.88-45.95-4.08-55.83-4.36-3.6-10.4-4.86-18.12-3.33a7.12 7.12 0 1 0-6.4 10.25Zm23.8 122.98c-.43 0-.86.05-1.3.1-.42.06-.85.11-1.28.11-11.38 1.72-21.26 7.09-27.48 14.82-6.88 8.37-9.02 19.97-5.37 29.2 3.65 9.66 13.95 16.1 23.4 15.03 6.66-.86 12.89-5.15 17.4-11.8 9.23-13.32 7.94-33.08-3.01-45.1-.42-.56-.94-1.04-1.49-1.54-.28-.26-.58-.53-.87-.82Z"
        clipRule="evenodd"
        css={mixBlendMultiply}
      />
      <path fill="#EF4931" d="M184.03 177.34 193 188l2.63-1 3.87-1 1.5-13.17-16.97 4.5Z" />
      <path
        fill="#fff"
        d="M156.33 149.2a82.93 82.93 0 0 0-4.08-4.93c-12.88-16.32-28.98-36.5-24.48-50.46 1.94-6.02 7.73-10.53 16.97-12.89l.86 3.22c-8.16 2.15-13.1 5.8-14.6 10.74-4.08 12.24 11.38 31.78 23.83 47.24 1.29 1.72 2.8 3.44 4.08 4.94l-2.58 2.15ZM210.88 134.6l-3.44-.43c.21-2.14.64-4.07.86-6.44 3-19.75 6.66-44.23-3-52.82-3.87-3.44-9.89-4.08-18.05-1.93l-.85-3.22c9.23-2.58 16.31-1.5 21.25 2.57 10.95 9.88 7.3 35.43 4.08 55.83-.21 2.15-.64 4.3-.85 6.44Z"
      />
      <circle cx="149.13" cy="81.13" r="7.13" fill="#0F3C6C" />
      <circle cx="183.13" cy="72.13" r="7.13" fill="#0F3C6C" />
      <path
        fill="#EF4931"
        d="M189.4 178.84c-12.67 0-24.9-15.03-34.57-28.78a3.43 3.43 0 0 1 .86-4.72 3.43 3.43 0 0 1 4.72.86c13.53 19.33 23.84 27.49 31.35 25.55 7.52-1.93 12.24-14.38 14.18-37.79.21-1.93 1.71-3.22 3.65-3 1.93.2 3.22 1.71 3 3.64-1.07 12.03-2.57 20.83-4.94 27.7-3.22 9.02-7.94 14.4-14.17 16.1-1.5.22-2.79.44-4.08.44Z"
      />
      <path
        fill="#EF4931"
        d="M192.32 268.36c-11.59 0-22.97-7.94-27.27-19.54-4.29-11.38-1.71-25.33 6.45-35.64 6.65-8.16 16.53-13.96 27.91-16.54-4.3-3.86-8.16-9.44-9.66-19.75-.22-1.93 1.07-3.65 2.79-3.87 1.93-.21 3.65 1.08 3.87 2.8 1.5 11.59 6.87 15.24 12.02 19.1l.22.22c9.23-.64 19.32.86 30.06 4.08 4.72 1.5 9.23 3.22 13.74 4.94 5.58 2.15 11.17 4.3 16.75 5.8 9.45 2.57 21.04 5.58 30.06 1.72 1.72-.65 3.65 0 4.51 1.71.65 1.72 0 3.65-1.72 4.51-11.16 4.94-24.26 1.3-34.57-1.29-6.01-1.5-11.8-3.86-17.4-5.8-4.29-1.71-8.8-3.43-13.3-4.72a97.73 97.73 0 0 0-20.83-3.86c11.38 14.6 12.24 36.07 1.71 51.53-5.58 8.16-13.74 13.53-22.11 14.6h-3.23Zm14.6-66.13c-.85 0-1.71.21-2.57.21-11.38 1.72-21.26 7.09-27.48 14.82-6.88 8.37-9.02 19.97-5.37 29.2 3.65 9.66 13.95 16.1 23.4 15.03 6.66-.86 12.89-5.15 17.4-11.8 9.23-13.32 7.94-33.08-3.01-45.1-.64-.86-1.5-1.5-2.36-2.36Z"
      />
      <path fill="#0F3C6C" d="M308.96 224.91a13.96 13.96 0 1 0 0-27.91 13.96 13.96 0 0 0 0 27.91Z" />
    </motion.g>
  </svg>
);

export const EscriptOnboardingHowItWorksStep = () => {
  useSegmentEvent('viewWelcomeScreen', { shouldTrackOnMount: true, payload: { page_number: 2 } });
  const history = useHistory();

  return (
    <SimpleFeatureLayout
      keyName={EscriptOnboardingStepName.how_it_works}
      title={`We deliver all your medications from all your doctors—for free`}
      description={`All doctors can send prescriptions to Capsule.`}
      body={{
        content: <StethoscopeArt />,
        type: 'artwork',
      }}
      cta1={{
        children: 'Continue',
        onClick: () => history.push(newOnboardingStep.toPath({ stepName: EscriptOnboardingStepName.insurance })),
      }}
    />
  );
};
